export default "__VITE_ASSET__ijvtfQeq__"